// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes';
import { createGlobalStyle } from 'styled-components';
import serviceWorkerProxy from './services/serviceWorkerProxy';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    height: 100%;
    overflow-y: auto;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    background: #1a1033;
    color: #fff;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  #root {
    min-height: 100vh;
    overflow-y: auto;
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(26, 16, 51, 0.5);
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

const App = () => {
  useEffect(() => {
    const initializeServiceWorker = async () => {
      if (window.location.protocol === 'https:' || window.location.hostname === 'localhost') {
        try {
          const registered = await serviceWorkerProxy.register();
          if (registered) {
            console.log('Service Worker proxy registrado com sucesso');
          } else {
            console.log('Service Worker proxy não foi registrado');
          }
        } catch (error) {
          console.error('Erro ao registrar Service Worker proxy:', error);
        }
      }
    };

    initializeServiceWorker();
  }, []);

  return (
    <BrowserRouter>
      <GlobalStyle />
      <AppRoutes />
    </BrowserRouter>
  );
};

export default App;